import { useEffect, useState } from "react";
import { CheckCircle2, Circle, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const Mark = ({ st }) => st === "ok" ? <CheckCircle2 size={18} className="shrink-0 text-[var(--accent)]" /> : st === "bad" ? <XCircle size={18} className="shrink-0 text-[#EF4444]" /> : <Circle size={18} className="shrink-0 text-[#555]" />;

export const JobberChecklist = ({ check }) => {
  const [req, setReq] = useState([]);
  useEffect(() => { api("/billing/import/requirements").then(setReq).catch(() => {}); }, []);
  const byKind = Object.fromEntries((check?.items || []).map((i) => [i.kind, i]));
  return (
    <ol className="space-y-2" data-testid="jobber-checklist">
      {req.map((r, n) => {
        const it = byKind[r.kind];
        const st = !check ? "todo" : it?.ok ? "ok" : "bad";
        return (
          <li key={r.kind} className={`flex gap-3 rounded-lg border p-3 text-sm ${st === "ok" ? "border-[var(--accent)]/50" : st === "bad" ? "border-[#EF4444]/50" : "border-[#2a2a2a]"}`} data-testid={`jobber-check-${r.kind}`}>
            <Mark st={st} />
            <div className="min-w-0">
              <p><b>{n + 1}. {r.label}</b>{it?.ok && <span className="ml-2 text-xs text-[#aaa]" data-testid={`jobber-check-${r.kind}-rows`}>{it.files.join(", ")} · {it.rows} rows</span>}</p>
              <p className="text-xs text-[#ccc]">In Jobber: {r.path}</p>
              {st === "bad" && it.problems.map((p, i) => <p key={i} className="mt-1 text-xs text-[#EF4444]" data-testid={`jobber-check-${r.kind}-problem-${i}`}>{p}</p>)}
            </div>
          </li>
        );
      })}
      {(check?.problems || []).map((p, i) => <li key={i} className="text-xs text-[#EF4444]" data-testid={`jobber-check-extra-${i}`}>{p}</li>)}
    </ol>
  );
};
